import {faUsers} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {dateFormatFR} from '../../../utils';
import DataTable from '../../../common/components/Datatable/Datatable';
import Screen from '../../../common/components/layout/Screen';
import Metadata from '../../../common/components/Metadata';
import {Span} from '../../../common/components/StyledComp';
import {FILTER_EXPRESSION_OPERATOR, FILTER_OPERATOR, ROLES} from '../../../common/constants';
import {GRAPHQL_QUERY_USERS} from '../../../common/queries/users';
import UserRowAction from './UserRowAction';
import DisplayBoolean from '../../../common/components/DisplayBoolean';

const columns = t => [
  {
    Header: '#',
    accessor: 'id',
    sortable: true,
  },
  {
    Header: t('dataTable.lastname'),
    Cell: ({cell}) => cell.value.toUpperCase(),
    accessor: 'lastName',
    sortable: true,
  },
  {
    Header: t('dataTable.firstname'),
    accessor: 'firstName',
    sortable: true,
  },
  {
    Header: t('dataTable.email'),
    accessor: 'email',
    sortable: true,
  },
  {
    Header: t('dataTable.phoneNumber'),
    accessor: 'mobilePhone',
  },
  {
    Header: t('dataTable.creation'),
    Cell: ({cell}) => dateFormatFR({date: cell.value}),
    accessor: 'createdAt',
  },
  {
    Header: t('dataTable.active'),
    Cell: ({cell}) => <DisplayBoolean bool={cell.value}/>,
    accessor: 'isActive',
  },
  {
    Header: t('action'),
    Cell: ({cell}) => <UserRowAction user={cell.value}/>,
    accessor: row => row,
  },
];

const initialFilters = {
  expressions: [{
    operator: FILTER_EXPRESSION_OPERATOR.And,
    filters: [{
      field: 'role',
      value: ROLES.USER,
    }],
  }],
};

const UsersListView = ({t}) => {
  const [advancedFilters, setAdvancedFilters] = React.useState(initialFilters);
  const onSearch = search => setAdvancedFilters({
    ...initialFilters,
    expressions: [
      ...initialFilters.expressions,
      {
        operator: FILTER_EXPRESSION_OPERATOR.Or,
        filters: [{
          field: 'id',
          operator: FILTER_OPERATOR.Like,
          value: `%${search}%`,
        }, {
          field: 'lastName',
          operator: FILTER_OPERATOR.Like,
          value: `%${search}%`,
        }, {
          field: 'firstName',
          operator: FILTER_OPERATOR.Like,
          value: `%${search}%`,
        }, {
          field: 'mobilePhone',
          operator: FILTER_OPERATOR.Like,
          value: `%${search}%`,
        }, {
          field: 'email',
          operator: FILTER_OPERATOR.Like,
          value: `%${search}%`,
        }],
      }],
  });
  const filters = {
    field: 'role',
    value: ROLES.USER,
    operator: FILTER_OPERATOR.Equal,
  };

  return (
    <Screen
      header={<Metadata meta={t('meta')} title={t('title')}/>}
      leftTitle={(
        <>
          <FontAwesomeIcon icon={faUsers} color={'rgb(201,0,95)'}/>
          <Span className="route-name">{t('dataTable.users')}</Span>
        </>
      )}>
      <DataTable
        columns={columns(t)}
        keyResult="users"
        query={GRAPHQL_QUERY_USERS}
        orderBy="lastName"
        advancedFilters={advancedFilters}
        filters={filters}
        onSearch={onSearch}/>
    </Screen>
  );
};

UsersListView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('user')(UsersListView);
